import React from "react";
import classnames from "classnames";
import useStyles from "./FmText.style";

declare type TextVariants = "headerTitle" | "standard" | "light" | "bigTitle" | "large" | "text";
interface FmTextProps {
  children: React.ReactNode | string;
  variant?: TextVariants;
  className?: string;
  onClick?: () => void;
}

const FmText = ({ children, className, onClick, variant = "standard" }: FmTextProps) => {
  const classes = useStyles();
  const spanClass = classnames(classes.standard, className, {
    [classes.headerTitle]: variant === "headerTitle",
    [classes.light]: variant === "light",
    [classes.bigTitle]: variant === "bigTitle",
    [classes.large]: variant === "large",
    [classes.text]: variant === "text",
    [classes.clickable]: !!onClick,
  });

  return (
    <div className={spanClass} onClick={onClick}>
      {children}
    </div>
  );
};

export default FmText;
